export default __webpack_public_path__ + "static/media/bag-closed.d8ea4ec1.png";